// src/utils/auditHelpers.js - CORRECT, NO CHANGES NEEDED

import {useCallback} from 'react';
import {collection, addDoc, serverTimestamp, getDoc, doc} from 'firebase/firestore';
import { db } from '../firebase'; // Import db directly
const userCache = new Map();

export const auditActionLabels = {
  'campaign_created': 'Campanha Criada',
  'coupons_generated': 'Cupons Gerados',
  'coupon_redeemed': 'Cupom Resgatado',
  'campaign_updated': 'Campanha Atualizada',
  'campaign_deleted': 'Campanha Excluída',
  'coupon_updated': 'Cupom Atualizado',
  'coupon_deleted': 'Cupom Excluído',
};

export const getActionLabel = (action) => auditActionLabels[action] || action.replace('_', ' ').toUpperCase();

const getUserInfo = async (user) => {
//  if (!profile) return {userId: 'system', userName: 'Sistema', userEmail: 'system@app.com'};
// If no user is provided (e.g., a system action), return a default object.
    if (!user || !user.id) return { userId: 'system', userName: 'Sistema', userEmail: 'system@app.com' };
  const cacheKey = user.uid;
  if (userCache.has(cacheKey)) return userCache.get(cacheKey);

  let userInfo = {
    userId: user.uid,
    userName: user.displayName || user.email?.split('@')[0] || 'Usuário Desconhecido',
    userEmail: user.email || 'unknown@email.com',
  };

  try {
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    if (userDoc.exists()) {
      const userData = userDoc.data();
      userInfo.userName = userData.name || userData.displayName || userInfo.userName;
      userInfo.userEmail = userData.email || userInfo.userEmail;
    }
  } catch (error) {
    console.error('Erro ao buscar dados do usuário no Firestore:', error);
  }

  userCache.set(cacheKey, userInfo);
  setTimeout(() => userCache.delete(cacheKey), 5 * 60 * 1000);

  return userInfo;
};

// export const useAuditLogger = (db, user) => {
export const useAuditLogger = (adminUser) => {
  const logAudit = useCallback(async (action, metadata = {}) => {
    if (!db) {
      console.error('Database (db) não está disponível para auditoria.');
      return;
    }
    try {
      const userInfo = await getUserInfo(db, adminUser);
      const auditData = {
        action,
        userId: userInfo.userId,
        userName: userInfo.userName,
        userEmail: userInfo.userEmail,
        timestamp: serverTimestamp(),
        metadata: {
          ...metadata,
          userAgent: navigator.userAgent,
        },
      };
      await addDoc(collection(db, 'audit_logs'), auditData);
    } catch (error) {
      console.error('Falha ao registrar auditoria:', error);
    }
  }, [db, adminUser]);

  const logCampaignCreation = useCallback((campaign) => {
    logAudit('campaign_created', {
      campaignId: campaign.id,
      campaignName: campaign.name,
      creditAmount: campaign.creditAmount,
    });
  }, [logAudit]);

  const logCouponCreation = useCallback((campaign, count) => {
    logAudit('coupons_generated', {
      campaignId: campaign.id,
      campaignName: campaign.name,
      count: count,
    });
  }, [logAudit]);

  const logCouponRedemption = useCallback((coupon, campaign, redeemedByUser) => {
    logAudit('coupon_redeemed', {
      couponId: coupon.id,
      couponCode: coupon.code,
      campaignId: campaign.id,
      redeemedBy: redeemedByUser.uid,
    });
  }, [logAudit]);

  return {
    logCampaignCreation,
    logCouponCreation,
    logCouponRedemption,
  };
};

export const formatAuditDate = (timestamp) => {
  if (!timestamp) return 'Data indisponível';
  try {
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleString('pt-BR', {dateStyle: 'short', timeStyle: 'medium'});
  } catch (error) {
    return 'Data inválida';
  }
};

export const formatAuditMetadata = (metadata) => {
  if (!metadata || typeof metadata !== 'object') return 'Sem detalhes';
  const {userAgent, ...details} = metadata;
  return Object.entries(details)
    .map(([key, value]) => `${key}: ${value}`)
    .join(' • ');
};

export const clearUserCache = () => {
  userCache.clear();
};

export default useAuditLogger;
